export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const VISIBILITY_SHOW = 'show';
export const VISIBILITY_HIDE = 'hide';

export const GROUP_STORAGE_DELAY = 1000;

export const HTTP_STATUS = {
  OK: 200,
  NO_CONTENT: 204,
  PRECONDITION_FAILED: 412,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502
};

export const LS_KEYS = {
  DEP: 'Dep',
  REPORT_DATE_FROM: 'ReportDateFrom',
  REPORT_DATE_TO: 'ReportDateTo',
  VISIBLE: 'visible',
  DRTS: 'Drts',
  REPORTS: 'Reports',
  USER: 'User',
  GROUP_NAME: 'groupName',
  REPORT_DATE: 'ReportDate'
};

export const VISIBILITY_STATE = {
  SHOW: 'show',
  HIDE: 'hide'
};

export const CSS_CLASSES = {
  HIDE: 'hide',
  NAVBAR_DARK: '.navbar-dark',
  HIDE_CONTAINER: '.hide-ili-nehide'
};

export const HTTP_CODES = {
  OK: 200,
  BAD_GATEWAY: 502,
  INTERNAL_SERVER_ERROR: 500
};

export const TOOLTIP_TYPES = {
  WAGE_RATE: 'wageRate',
  SALARY_SUPPLEMENTS: 'salarySupplements'
};

export interface ReportSegment {
  workDays: number;
  restDays: number;
}

export interface ReportRecord {
  workStart?: string;
  workEnd?: string;
  segments: ReportSegment[];
  salarySupplements: number;
  wageRate: number;
  [key: string]: any;
}

export interface ReportSummary {
  id: string;
  username: string;
  salarySupplements: number;
  wageRate: number;
}

export interface ReportModel {
  userID: string;
  lastName: string;
  summaryRecord: ReportSummary;
  records: ReportRecord[];
  howSalaryCalculated: Array<string | number | null>;
}

export interface KarmaInfo {
  description: string;
  link?: string;
}

export interface CalendarMonth {
  month: string;
  year: number;
  days: number[];
}

export interface UserGroup {
  name: string;
}

export interface UserProfile {
  id: string;
  salary: number;
}


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/my-working-report/my-working-report.constants.ts